import { DeviceOutputState } from "./DomainEnums";

const isTabletAppDeviceOutput = () => {
    return determineOutputType() === DeviceOutputState.TABLET_APP;
};

const isMobileDeviceOutput = () => {
    return determineOutputType() === DeviceOutputState.MOBILE;
};

const isMobileAppDeviceOutput = () => {
    return determineOutputType() === DeviceOutputState.MOBILE_APP;
};

const isDeviceOutputMobileOrMobileApp = () => {
    const deviceType = determineOutputType();
    return (
        deviceType === DeviceOutputState.MOBILE ||
        deviceType === DeviceOutputState.MOBILE_APP
    );
};

const isDeviceOutputTabletOrTabletApp = () => {
    const deviceType = determineOutputType();
    return (
        deviceType === DeviceOutputState.TABLET ||
        deviceType === DeviceOutputState.TABLET_APP
    );
};

const isDeviceOutputDesktop = () => {
    const deviceType = determineOutputType();
    return deviceType === DeviceOutputState.DESKTOP;
};

const isDeviceSupportsTouch =
    "ontouchstart" in window || navigator.maxTouchPoints > 0;

const determineOutputType = (): string => {
    const cookieValue = document.cookie
        .split("; ")
        .find((row) => row.startsWith("deviceoutput="))
        ?.split("=")[1]
        .toLowerCase();

    switch (cookieValue) {
        case "mobile":
            return DeviceOutputState.MOBILE;
        case "app":
            return DeviceOutputState.MOBILE_APP;
        case "desktop":
            return DeviceOutputState.DESKTOP;
        case "tablet":
            return DeviceOutputState.TABLET;
        case "tabletapp":
            return DeviceOutputState.TABLET_APP;
    }

    return DeviceOutputState.DESKTOP;
};

export {
    isMobileDeviceOutput,
    isTabletAppDeviceOutput,
    determineOutputType,
    isDeviceOutputMobileOrMobileApp,
    isDeviceOutputTabletOrTabletApp,
    isDeviceOutputDesktop,
    isMobileAppDeviceOutput,
    isDeviceSupportsTouch,
};
